import { TrendingResp } from "@/types/farcaster"

import { AllPostsListItem } from "components/public/BlogTheme/AllPostsListItem"
import { ReactNode, useEffect, useState } from "react"

import InfiniteScroll from "react-infinite-scroll-component"
import {
  LoadingContainer,
  TextContainer,
} from "components/Discover/TextContainer"
import { ErrorResponse } from "@types"
import { useRouter } from "next/router"

type PropsType = {
  // Undefined when it's loading the fallback
  data?: TrendingResp
  errorMsg?: any

  // Message used when there are no posts in the discover feed.
  emptyMsg?: ReactNode
  fetchData: (
    page: number,
    tag?: string
  ) => Promise<TrendingResp | ErrorResponse>
}

export default function DiscoverFeed({
  errorMsg,
  emptyMsg,
  data,
  fetchData,
}: PropsType) {
  const tag = useRouter().query?.tag?.[0]

  // When fallback resolves,
  // update the posts to kick off proper re-renders
  useEffect(() => {
    setPosts(data)
  }, [data])

  const [posts, setPosts] = useState<TrendingResp | undefined>(data)
  const [hasMore, setHasMore] = useState<boolean>(true)
  const [error, setError] = useState<undefined | string>(errorMsg)

  // Start on 2, since we already have the first page.
  const [page, setPage] = useState(2)

  const _fetchData = async () => {
    const ok = await fetchData(page, tag)
    if ("msg" in ok) {
      setError(ok.msg)
      return
    }

    const mergedPosts = [...(posts || []), ...ok]

    setPage(page + 1)
    setPosts(mergedPosts)
    if (ok.length === 0) {
      setHasMore(false)
    }
  }

  if (error) {
    return <TextContainer>{errorMsg}</TextContainer>
  }

  {
    /* Used since fallback is true */
  }
  if (posts === undefined) {
    return <LoadingContainer />
  }

  if (posts?.length === 0) {
    return (
      <TextContainer>
        {emptyMsg || `It doesn't look like there's any posts yet.`}
      </TextContainer>
    )
  }

  console.log("Rendering discover feed!", posts)

  return (
    <div>
      <div>
        <InfiniteScroll
          dataLength={posts.length} //This is important field to render the next data
          next={_fetchData}
          hasMore={hasMore}
          loader={<TextContainer>Loading...</TextContainer>}
          endMessage={<TextContainer>Yay! You've seen it all.</TextContainer>}
        >
          <div className="max-w-2xl mx-auto divide-slate-200 divide-y">
            {posts.map((postEntry, idx) => (
              <AllPostsListItem
                discoverPage
                key={postEntry.post.id}
                user={postEntry.user}
                note={postEntry.post}
                blog={postEntry.blog}
              />
            ))}
          </div>
        </InfiniteScroll>
      </div>
    </div>
  )
}
